import { render, staticRenderFns } from "./Teilzeit.vue?vue&type=template&id=2f4d860b&scoped=true"
import script from "./Teilzeit.vue?vue&type=script&lang=js"
export * from "./Teilzeit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d860b",
  null
  
)

export default component.exports